<template>
    <div ref="calendarContainer">
        <KeepAlive>
            <FullCalendar
                ref="calendar"
                :options="calendarOptions">
                <template #eventContent="event">
                    <slot v-bind="event" />
                </template>
            </FullCalendar>
        </KeepAlive>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import deLocale from "@fullcalendar/core/locales/de";

export default {
    name: "BaseCalendar",
    components: {
        FullCalendar
    },
    props: {
        eventSources: {required: true, type: Array},
        editable: {type: Boolean, default: false},
        printable: {type: Boolean, default: false},
        newEventDefaultTitle: {type: String, default: "Neue Buchung"},
        newEventColor: {type: String},
        iFrameType: {type: String},
        loading: {required: false}
    },
    data() {
        return {
            calendarPlugins: [dayGridPlugin],
            calendarApi: null
        }
    },
    computed: {
        calendarOptions() {
            const self = this
            return {
                plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
                initialView: 'dayGridMonth',
                editable: this.editable,
                locale: deLocale,
                slotDuration: "01:00:00",
                forceEventDuration: true,
                dayMaxEvents: 3,
                views: {
                    dayGridDay: {
                        dayMaxEvents: 10,
                        titleFormat: {year: 'numeric', month: 'long', day: 'numeric', weekday: 'short'}
                    },
                    dayGridMonth: {
                        titleFormat: {year: 'numeric', month: 'long'}
                    }
                },
                navLinks: true,
                headerToolbar: {
                    start: 'dayGridMonth,dayGridDay',
                    center: 'title',
                    end: 'prev,next'
                },
                footerToolbar: this.printable ? {
                    end: 'printButton'
                } : null,
                contentHeight: 'auto', // stop scrollbars
                eventSources: this.eventSources,
                progressiveEventRendering: true
            }
        }
    },
    methods: {
        print() {
            document.body.classList.add('printing')
            const calendar = this.$refs.calendarContainer.cloneNode(true)
            calendar.classList.add('printable')
            calendar.style.width = this.$refs.calendarContainer.offsetWidth + 'px'
            document.body.appendChild(calendar)

            window.addEventListener(
                "afterprint",
                () => {
                    document.body.removeChild(calendar);
                    document.body.classList.remove('printing')
                    this.$refs.calendar.getApi().render()
                },
                {once: true}
            );

            this.$nextTick(() => {
                this.$refs.calendar.getApi().render()
                window.print()
            })
        }
    },
    mounted() {
        this.calendarApi = this.$refs.calendar?.getApi()
    }
}
</script>
